import { upcomingPastBookingTabAction } from "../../../Actions/LogicActions/Booking/UpcomingPastBookingTabAction";
import { getAtoSuggestionCacheDataAction } from "../../../Actions/LogicActions/RetrieveBooking/GetAtoSuggestionCacheDataAction";
import { retrieveBookingAction } from "../../../Actions/LogicActions/RetrieveBooking/RetrieveBookingAction";
import { retrieveBookingControlsAction } from "../../../Actions/UIActions/RetrieveBooking/RetrieveBookingControlsAction";
import { retrieveBookingShowModalAction } from "../../../Actions/UIActions/RetrieveBooking/RetrieveBookingShowModalAction";
import { _eventBus } from "../../../core/events/EventBus";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { StepFlow } from "../../../core/flows/StepFlow";
import { isActionRunSuccessfully } from "../../../Lib/Utils/validationUtil";
import { bookingTree } from "../../../Orchestrator/ConstantTree";
import { IRetrieveBooingActionParams, IRetrieveBookingControlsActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/RetrieveBookingParams";
import { ITabChangeActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/UpcomingPastBookingActionParams";
import { AfterSaleBookingContext } from "../../AfterSalesBookingFlow/Context/AfterSaleBookingContext";

class RetrieveBookingInitStep extends StepFlow {
    get stepName() { return "RetrieveBookingInit_Step"; }

    async onEventSetup(): Promise<void> {
        this.registerEventSubscription(
            _eventBus.on<IRetrieveBooingActionParams, void>({
                eventName: bookingTree.RetrieveBooking.Fetch.Click,
                handler: async ({ data }) => {
                    if (data) {
                        await retrieveBookingAction.setParams(data)
                        await retrieveBookingAction.execute()
                        if (isActionRunSuccessfully(retrieveBookingAction)) {
                            const result = retrieveBookingAction.result!
                            if (result.status === "success") {
                                const context = this.getCtx<AfterSaleBookingContext>("afterSaleBookingContext");
                                if (context) {
                                    context.routeTo = ["UpcomingPastBookingFlow"]
                                    this.next()
                                }
                            }
                        }
                    }
                }
            })
        )
        this.registerEventSubscription(
            _eventBus.on<IRetrieveBookingControlsActionParams, void>({
                eventName: bookingTree.RetrieveBooking.OnChange,
                handler: async ({ data }) => {
                    if (data != undefined) {
                        await retrieveBookingControlsAction.setParams(data)
                        await retrieveBookingControlsAction.execute()
                    }
                }
            })
        )
        this.registerEventSubscription(
            _eventBus.on<boolean, void>({
                eventName: bookingTree.RetrieveBooking.Modal.Close,
                handler: async ({ data }) => {
                    if (data != undefined) {
                        await retrieveBookingShowModalAction.setParams(data)
                        await retrieveBookingShowModalAction.execute()
                        if (isActionRunSuccessfully(retrieveBookingShowModalAction)) {
                            const result = retrieveBookingShowModalAction.result!
                            if (result.status === "success") {
                                const context = this.getCtx<AfterSaleBookingContext>("afterSaleBookingContext");
                                if (context) {
                                    context.routeTo = ["UpcomingPastBookingFlow"]
                                    this.next()
                                }
                            }
                        }
                    }
                }
            })
        )

        /**
         * This event required here because,
         * Once Retrieve booking is started we close the upcoming flow and not abel to redirect to the
         * Upcoming and past booking section.
         * So required this event here because from retrieve booking we can manage it.
        */
        this.registerEventSubscription(
            _eventBus.on<ITabChangeActionParams, void>({
                eventName: bookingTree.UpcomingPast.TabDefaultChange,
                handler: async (payload) => {
                    upcomingPastBookingTabAction.setParams(payload.data!)
                    await upcomingPastBookingTabAction.execute();
                    const context = this.getCtx<AfterSaleBookingContext>("afterSaleBookingContext");
                    if (context) {
                        context.routeTo = ["UpcomingPastBookingFlow"]
                        this.next()
                    }
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<void, void>({
                eventName: bookingTree.RetrieveBooking.AutoSuggestionList.Get,
                handler: async (payload) => {
                    await getAtoSuggestionCacheDataAction.execute()
                }
            })
        )
    }

    async onExecute(): Promise<void> {
        console.log("Retrieve Booking Init Step Execute.............................")
        _eventBus.emit({
            eventName: bookingTree.RetrieveBooking.AutoSuggestionList.Get,
        });
    }
}

export const RetrieveBookingInitStepDeclaration = new StepDefinition({
    stepName: "RetrieveBookingInit_Step",
    stepClass: RetrieveBookingInitStep
});